import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { HaulerList } from '../models/hauler.model';

@Injectable({
  providedIn: 'root',
})
export class HaulerService {
  baseHaulerUrl = environment.baseUrl;
  constructor(private http: HttpClient) {}

  getHaulerList(): Observable<HaulerList[]> {
    var url = `${this.baseHaulerUrl}haulers`;
    return this.http.get<HaulerList[]>(url);
  }
  deleteHauler(id: any): Observable<any> {
    const url = `${this.baseHaulerUrl}haulers`;
    return this.http.delete(`${url}?haulerId=${id}`);
  }
  createHauler(formData: any): Observable<any> {
    var url = `${this.baseHaulerUrl}haulers`;
    return this.http.post<any>(url, formData);
  }
  getHaulerDetailsById(id: any): Observable<any> {
    const url = `${this.baseHaulerUrl}haulers/GetHaulerById`;
    return this.http.get<any>(`${url}?haulerId=${id}`);
  }
}
